import * as Actions from '../Actions/CidadeActions';
// import _ from '@lodash';

const initialState = {
    data : null,
};

const CidadeReducer = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.GET_CIDADE:
        {
            return {
                ...state,
                data: action.payload,
            };
        }
        case Actions.ERROR_CIDADE:
        {
            return {
                ...state,
                success: false,
                cidadeDialog: {
                    props:
                    {
                        open: true,
                        error: action.payload
                    },
                    data : null
                 }
            };
        }
        case Actions.CIDADE_INFO:
        {
            return {
                ...state,
                success: true,
                cidadeDialog: {
                    props:
                    {
                        open: true,
                        info: action.payload
                    },
                    data : null                   
                }
            };
        }
        case Actions.CIDADE_WARNING:
        {
            return {
                ...state,
                success: true,
                cidadeDialog: {
                    props:
                    {
                        open: false,
                        warning: action.payload
                    },
                    data : null                   
                }
            };
        }
        default:
        {
            return state;
        }
    }
};

export default CidadeReducer;
